export enum EnumFinancialType {
    percentage = "Porcentagem",
    monetary = "Monetário",

}
